<template>
  <div>
    <label>
      Image Name
    </label>
    <input 
      v-model="data.reply_image_name"
      type="text" 
      name="reply_image_name" 
      placeholder="Please enter the image name"
    />
    <div v-if="!name">
      <br />
      <label>
        Photographer
      </label>
      <input 
        v-model="data.reply_photographer"
        type="text" 
        name="reply_photographer" 
        placeholder="Please enter the photographer name"
      />
    </div>
    <br />
    <br />
    <article>
      <div v-if="data.reply_image">
        <img
          v-if="file"
          :src="file.previewImage" style="width:auto;height:200px;"
        />
        <img 
          v-else
          :src="'//milim-interface.s3.amazonaws.com/samples/' + data.sample" style="width:auto;height:200px;"
        />
        <br />
        <button @click="handleClickRemoveSampleImage">
          Remove sample image
        </button>
      </div>
      <interface-upload-box
        v-if="!data.reply_image"
        doc-type="interface" 
        doc-group="group1"
        doc-file-types="image/jpeg"
        @select="handleSelect"
      />
      <div class="image_details">
        <div class="instructions">
          <p>
            When uploading an image please ensure that:
          </p>
          <ul>
            <li>Only 1 image per reply, however you can add multiple replies</li>
            <li>Upload a jpeg file</li>
            <li>Maximum compressed file size is 10MB. Uncompressed size should be 25 MBs +</li>
            <li>Maximum image dimensions should be 5000px along the longest edge</li>
          </ul>
        </div>
      </div>
    </article>
    <br />
    <button
      class="align_right"
      @click="handleClickSubmit"
      :disabled="!isInitial || !isValid"
    >
      Submit
    </button>
    <span style="float: right; padding-top: 10px; padding-right: 20px;">
      <input 
        v-model="agreeToTerms"
        type="checkbox" 
        id="terms" 
        name="terms" 
      />
      <label for="terms">
        Agree to the <a href="#terms_overlay">terms and conditions</a>
      </label>
    </span>
  </div>
</template>

<script>
import InterfaceUploadBox from './InterfaceUploadBox.vue';

const STATE_INITIAL = 0,
  STATE_SAVING = 1,
  STATE_SAVED = 2,
  STATE_FAILED = 3; 

export default {
  name: 'ImageReplyForm',
  props: {
    postId: Number,
    isAdmin: Boolean,
    name: String,
  },
  components: {
    InterfaceUploadBox,
  },
  data: function(){
    return {
      currentState: null,
      data: {
        post_id: this.postId,
        reply_image_name: null,
        reply_photographer: null,
        // reply_message: null,
        reply_image: null,
        image_base64: null
      },
      file: null,
      agreeToTerms: false,
    }
  },
  computed: {
    isInitial: {
        get () {
            return this.currentState === STATE_INITIAL;
        },
    },
    isSaving: {
        get () {
            return this.currentState === STATE_SAVING;
        },
    },
    isSaved: {
        get () {
            return this.currentState === STATE_SAVED;
        },
    },
    isFailed: {
        get () {
            return this.currentState === STATE_FAILED;
        },
    },
    isValid: {
        get () {
            return (this.data.reply_image_name !== null && this.data.reply_image_name !== '') 
              && (this.data.reply_photographer !== null && this.data.reply_photographer !== '') 
              && (this.data.reply_image !== null && this.data.reply_image !== '')
              && this.agreeToTerms;
        },
    },
  },
  created: function () {
    this.currentState = STATE_INITIAL;
  },
  methods: {
    handleClickSubmit() {
      this.save();
    },
    handleClickRemoveImage() {
      this.file = null;
      this.data.reply_image = null;
      this.data.image_base64 = null;
    },
    handleSelect(file) {
      this.file = file;
      this.data.reply_image = file.name;
      this.data.image_base64 = file.previewImage;
    },
    save() {
      this.currentState = STATE_SAVING;
      const self = this;
      // console.log(this.data);
      // console.log(window.baseUrl);
      this.axios.post(window.baseUrl + 'api/reply', this.data).then(response => {
        // console.log(response.data.responseResult.data);
        console.log(response.data.responseResult);
        // self.notes = response.data.responseResult.data;
        self.onSaveComplete();
      });
    },
    onSaveComplete() {
      const self = this;
      this.currentState = STATE_SAVED;
      // Set redirect 
      setTimeout(function(){ 
          window.location.replace(window.baseUrl + 'view/request/' + self.postId);
      }, 50);
    },
  }
}
</script>
